<template>

    <div class="d-flex justify-space-between ml-2">

        <div class="ma-2 d-flex">

            <link-avatar :locale="locale"></link-avatar>

            <v-icon class="ml-2" color="grey">mdi-link</v-icon>

            <div class="ml-2 align-self-center">
                <v-tooltip color="primary" top>
                    <template v-slot:activator="{ on }">
                        <v-card flat color="transparent"
                                v-on="on"
                                @click="copyClicked(url)"
                                class="cursor-pointer">
                            {{ url }}
                        </v-card>
                    </template>
                    Copy to clipboard
                </v-tooltip>
            </div>
        </div>

        <div class="d-flex">
            <v-tooltip color="primary" top max-width="300">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on"
                           small
                           @click="registerClicked(url)"
                           class="elevation-0 align-self-center"
                           color="secondary">
                        REGISTER
                    </v-btn>
                </template>
                <span>
                    Register a real panelist
                </span>
            </v-tooltip>

            <v-tooltip color="primary" top max-width="300">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on"
                           small
                           @click="linkClicked(url)"
                           class="elevation-0 ml-2 mr-4 align-self-center"
                           color="primary">
                        TEST
                    </v-btn>
                </template>
                <span>
                    Launch the registration survey in test mode. No panelist will be created.
                </span>
            </v-tooltip>

        </div>

    </div>

</template>

<script>

import TitleCardList from "../../../components/UI/TitleCardList";
import {clipboardMixin} from "../../../components/mixins/clipboardMixin";
import LinkAvatar from "./LinkAvatar";

export default {

    name: "RegistrationLinks",

    mixins: [clipboardMixin],

    components: {
        LinkAvatar,
        TitleCardList
    },

    props: {
        subPanel: {
            required: true,
            type: Object
        },
        locale: {
            type: Object,
            required: false,
            default: null,
        },
    },

    computed: {
        url() {
            let base = 'https://' + new URL(window.location.href).hostname + '/registration/' + this.subPanel.id;

            if (this.locale) {
                base += '/' + this.locale.code;
            }

            return base;
        },
    },

    methods: {

        copyClicked(url) {
            this.copyToClipboard(url)
            Bus.$emit('flash-message', {message: 'URL copied to clipboard!'});
        },

        linkClicked(url) {
            window.open(url + '?test', '_blank').focus();
        },

        registerClicked(url) {
            window.open(url, '_blank').focus();
        }
    }
}
</script>
